import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const districtDropdown = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/district`,
    );

    return response.data.map((item) => ({
      key: item.disId,
      text: item.disDistrict,
      value: item.disId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const districtByStateAndStartsWith = async ({ searchText, id }) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/district/namestartswith/${id}`,
      searchText,
    );
    console.log(response);
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const districtName = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/district/name/${id}`,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const districtCreate = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/district/create`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateDistrict = async (id, data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/district/update/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getByIdDistrict = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/district/get-by/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const createDistrictsInBulk = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/district/create-bulk`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating districts in Bulk:", error);
    throw error;
  }
};
